import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../core/auth.service';
import {ModalDirective} from "ngx-bootstrap/modal";
import { TemplatesService } from '../templates.service';
import {TinymceComponent} from "angular2-tinymce";

@Component({
    templateUrl: 'templates-modal.component.html',
    styleUrls: ['templates-modal.component.scss']
})

export class TemplatesModalComponent implements OnInit {
    type: string;
    url = 'templates';
    errorMessage = '';
    successMessage = '';
    formSubmitted: boolean = false;
    params: any = {};
    clinicId = null;  // value null cause match api defined
    form: FormGroup;
    defaultContent: string = '';
    emailTemplate: Object = {};
    showRevertButton: boolean = false;
    regexForQuestionnaireTag = /\[questionnaire(=(.*?))?\](.*?)\[\/questionnaire\]/;

    noTitleTypeArr = [
        'support',
        'clinic_support',
        'help_patients',
        'help_patient',
        'help_di_overview',
        'help_di_symptom',
        'help_home',
    ];

    @ViewChild('modal', { static: false }) protected modal: ModalDirective;
    @ViewChild('tinymce', { static: false }) private editor: TinymceComponent;
    @ViewChild('tinymceDisclaimer', { static: false }) private tinymceDisclaimer: TinymceComponent;

    constructor(protected fb: FormBuilder,
                protected authService: AuthService,
                private route: ActivatedRoute,
                public router: Router,
                protected templatesService: TemplatesService) {
    }

    ngOnInit() {
        this.buildForm();

        this.route.params.subscribe(params => {
            this.params = params;

            if (params && params['clinicId']) {
                this.clinicId = params['clinicId'];
            }

            this.route.parent.params.subscribe(routeParams => {
                if (routeParams && routeParams['clinicId']) {
                    this.clinicId = routeParams['clinicId'];
                }

                this.loadModalData();
            })
        });
    }

    get isClinicTemplate() {
        return this.authService.isClinicAdmin || this.clinicId;
    }

    get notShowTitle() {
        return this.noTitleTypeArr.includes(this.emailTemplate['type']);
    }

    ngAfterViewInit() {
        this.modal.config.backdrop = false;
        this.modal.config.ignoreBackdropClick = true;
        this.modal.config.keyboard = false;

        this.showModal();
    }

    buildForm(): void {
        this.form = this.fb.group({
            'id': ['', [Validators.required]],
            'clinic_id': [''],
            'title': ['', [Validators.required]],
            'content': [' ', [Validators.required]],
            'email_subject': [' ',[Validators.required]],
            'email_header': [' ', [Validators.required]],
            'disclaimer_text': ['']
        });
    }

    getDefault(): string {
        return this.defaultContent;
    }

    hideModal() {
        this.router.navigate(['./'],
            {
                        relativeTo: this.route.parent,
                        queryParams: {
                            clinicId: this.clinicId
                        }
            });
    }

    loadModalData() {
        this.templatesService.read(this.params['id'], this.params['languageCode'], this.clinicId || '')
            .subscribe(response => {
                    this.emailTemplate = response['template'];

                    this.emailTemplate['language_flag'] = "/assets/icon/flags/"
                        + this.emailTemplate['language_code'].toLowerCase()
                        + ".png";

                    this.emailTemplate['clinic_id'] = this.emailTemplate['clinic_id'] || this.clinicId;

                    this.showRevertButton = this.emailTemplate.hasOwnProperty('customized')
                        ? this.emailTemplate['customized'] : false;

                    this.form.reset(this.emailTemplate);

                    if (this.emailTemplate['type'] == 'se_questionnaire' || this.emailTemplate['type'] == 'questionnaire_reminder') {
                        this.form.controls['content'].setValidators([Validators.required, <any>Validators.pattern(this.regexForQuestionnaireTag)]);
                    }

                    if (this.emailTemplate['add_disclaimer']) {
                        this.tinymceDisclaimer.editor.setMode('design');
                    } else {
                        this.tinymceDisclaimer.editor.setMode('readonly');
                    }
                }
            );
    }

    /**
     * Revert template
     */
    resetDefaultTemplate() {
        this.emailTemplate['title'] = this.emailTemplate['original_title'];
        this.emailTemplate['content'] = this.emailTemplate['original_content'];
        this.emailTemplate['clinic_id'] = this.emailTemplate['clinic_id'] || this.clinicId;

        this.emailTemplate['add_disclaimer'] = this.emailTemplate['origin_add_disclaimer'];
        this.emailTemplate['disclaimer_text'] = this.emailTemplate['origin_disclaimer_text'];
        this.emailTemplate['email_subject'] = this.emailTemplate['origin_email_subject'];
        this.emailTemplate['email_header'] = this.emailTemplate['origin_email_header'];
        this.form.reset(this.emailTemplate);
    }

    showModal() {
        this.modal.show();
    }

    changeDisclaimer() {
        this.emailTemplate['add_disclaimer'] = !this.emailTemplate['add_disclaimer'];
        if (this.emailTemplate['add_disclaimer']) {
            this.tinymceDisclaimer.editor.setMode('design');
        } else {
            this.tinymceDisclaimer.editor.setMode('readonly');
        }
    }

    /**
     * Submit update of email templates
     *
     * @param emailTranslationForm
     * @param {boolean} isValid
     */
    submit(emailTranslationForm: any, isValid: boolean): void {
        this.formSubmitted = true;

        if (!isValid) {
            return;
        }

        this.resetErrors();

        this.templatesService.save(this.params['id'], emailTranslationForm, this.emailTemplate).subscribe(
            response => {
                this.successMessage = response['message'];

                setTimeout(() => {
                    this.successMessage = '';
                    this.hideModal();
                }, 2000);
            });
    }

    resetErrors() {
        if (this.errorMessage.length > 0) {
            this.errorMessage = '';
        }
    }

}
